import { HeadingS, BodyM } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import CustomConfirmationDialog from 'components/CustomConfirmationDialog/CustomConfirmationDialog';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/payments/payAnyBillStyle';
import { makeStyles } from '@material-ui/styles';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IPaymentRejectedDialogProps {
	isOpen: boolean;
	hideDialog: () => void;
}
const PaymentRejectedDialog = ({ isOpen, hideDialog }: IPaymentRejectedDialogProps) => {
	const classes = useStyles();

	return (
		<CustomConfirmationDialog
			isOpen={isOpen}
			isError
			hideDialog={hideDialog}
			header={<BodyM disableMargin>{translate('payments.topup.paymentRejected.description')}</BodyM>}
		>
			<div className={classes.paymentRejectedBody}>
				<HeadingS color="danger">{translate('payments.topup.paymentRejected')}</HeadingS>
			</div>
		</CustomConfirmationDialog>
	);
};

export default PaymentRejectedDialog;
